
import {
    Call,
    ApiUrl,
    GenerateURL,
    ParseGeneralResponse,
  } from "../../javascripts/api/ApiUtils";


export function updateActiveWarehouse(activeWarehouseIds) {
    const url = ApiUrl("v1/users/update_active_warehouse");
    const method = "PUT";
    const data = {
      active_warehouse_ids: activeWarehouseIds,
    };
  
    return Call(method, url, data, ParseGeneralResponse, {
      responseDataKeys: { user: "user", pending_orders_count: "pending_orders_count"},
    });
  }

export function fetchAgents(org_id) {
  const url = ApiUrl(`v2/tenders/list_of_agents?organization_id=${org_id}`);
  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: { agentsList: "agent_details" },
    },
    false
  );
}
